import { Panel } from 'primereact/panel';
import React, { useEffect, useState } from 'react';

import DisputeNeedsReviewPillstatus from '../../../assets/DisputeNeedsReviewPillstatus.png';
import DisputeReviewedPillStatus from '../../../assets/DisputeReviewedPillStatus.png';
import { MetricPayoutTable } from '../../../components/metricPayoutTable/MetricPayoutTable';
import { PillStatus } from '../../../components/pillsStatus/PillStatus';
import { useGetEmployeeMetricAllPayoutsQuery } from '../../../pages/metricdashboard/metricDashboardSlice';

const teamLeadPayoutTableColumns = [
    { id: 1, filter: true, name: 'Date', field: 'date', template: 'dateBodyTemplate' },
    { id: 2, filter: true, name: 'Scorecard', field: 'scorecard_name', template: '' },
    {
        id: 3,
        filter: true,
        name: 'Metrics Attained',
        field: 'total_metrics_attained',
        template: 'metricsMetBodyTemplate',
    },
    { id: 4, filter: true, name: 'Metrics Reported', field: 'total_metrics_reported', template: '' },
    { id: 5, filter: true, name: 'Eligiblility', field: 'eligible', template: '' },
    { id: 6, filter: true, name: 'Payout Amount', field: 'payout', template: 'priceBodyTemplate' },
    { id: 7, filter: true, name: 'Approval Status', field: 'approval_status_name', template: '' },
];

const teamLeadPayoutFilterColumns = [
    'date',
    'scorecard_name',
    'total_metrics_attained',
    'total_metrics_reported',
    'eligible',
    'payout',
];

interface PropTypes {
    empNum?: number;
    primaryApprovalWindowData?: [];
    scoreCardDisputesDataValue?: [];
    scorecardVersion?: number;
    inputyear?: number;
    inputmonth?: number;
}

const TeamLeadPayout = ({ empNum, primaryApprovalWindowData, scoreCardDisputesDataValue, scorecardVersion,inputyear,inputmonth }: PropTypes) => {
    const [primaryApprovalWindowDataValue, setPrimaryApprovalWindowDataValue] = useState<any>([]);
    const [teamLeadPayoutPillStatus, setLeadTeamPayoutPillStatus] = useState({ status: '', icon: '', tooltip: '', bgColor: '' });
    const [currentApprovalWindowStatus, setCurrentApprovalWindowStatus] = useState(0);
    const [scDisputesPill, setScDisputesPill] = useState({ status: '', icon: '', tooltip: '', bgColor: '' });
    const [scoreCardDisputesData, setScoreCardDisputesData] = useState<any>([]);

    const { data: teamLeadPayoutData } = useGetEmployeeMetricAllPayoutsQuery(
        {
            employeenumber: empNum,
            scorecardroleid: 2,
        },
        {
            skip: !empNum,
        }
    );

    useEffect(() => {
        setPrimaryApprovalWindowDataValue(primaryApprovalWindowData);
        setScoreCardDisputesData(scoreCardDisputesDataValue);
        if (primaryApprovalWindowDataValue?.data?.length > 0) {
            setCurrentApprovalWindowStatus(
                primaryApprovalWindowDataValue?.data[0]?.approval_window_status_id
            );
        }
    }, [primaryApprovalWindowDataValue, primaryApprovalWindowData,scoreCardDisputesDataValue]);

    useEffect(() => {
        if (teamLeadPayoutData?.data?.length > 0) {
            const selectedMonthApprovalStatus: any = teamLeadPayoutData?.data?.filter((item:any) => item.month === inputmonth && item.year === inputyear && item.scorecard_version_id===scorecardVersion);
            if (selectedMonthApprovalStatus?.length > 0 && selectedMonthApprovalStatus[0]?.approval_status_name === 'Disqualified') {
                setLeadTeamPayoutPillStatus({
                    status: 'Disqualified',
                    icon: '',
                    tooltip: 'Disqualified',
                    bgColor: '#E23636',
                })
            }
            else if (selectedMonthApprovalStatus?.length > 0 && selectedMonthApprovalStatus[0]?.approval_status_name === 'Disputed') {
                setLeadTeamPayoutPillStatus({
                    status: 'Disputed',
                    icon: '',
                    tooltip: 'You can resolve disputes for Agents. Agents then need to review the resolved metrics.',
                    bgColor: '#E23636',
                })
            }
            else if (selectedMonthApprovalStatus?.length > 0) {
                setLeadTeamPayoutPillStatus({
                    status: selectedMonthApprovalStatus[0]?.approval_status_name,
                    icon: '',
                    tooltip: selectedMonthApprovalStatus[0]?.approval_status_name,
                    bgColor: '#64d96e',
                })
            }
            else setLeadTeamPayoutPillStatus({ status: '', tooltip: '' , icon: '', bgColor: ''});
        }
        else setLeadTeamPayoutPillStatus({ status: '', tooltip: '' , icon: '', bgColor: ''});
    }, [teamLeadPayoutData, primaryApprovalWindowDataValue]);

    useEffect(() => {
        if (scoreCardDisputesData?.data) {
            const disputedRow = scoreCardDisputesData?.data.filter((x: any) => {
                if (x.disputeStatus === 'Open') return x;
                else return '';
            });
            if (disputedRow.length > 0) {
                setScDisputesPill({
                    status: 'Disputed',
                    icon: DisputeNeedsReviewPillstatus,
                    tooltip: ' Please resolve scorecard disputes',
                    bgColor: '#E23636',
                });
            } else
                setScDisputesPill({
                    status: 'Reviewed',
                    icon: DisputeReviewedPillStatus,
                    tooltip: ' All Reviewed.',
                    bgColor: '#64d96e',
                });
        } else setScDisputesPill({ status: '', icon: '', tooltip: '', bgColor: '' });
    }, [scoreCardDisputesData]);

    return (
        <Panel
            headerTemplate={(options) =>
                // scorecardDisputeHeader(options, 'My Payouts', teamLeadPayoutPillStatus)
                PillStatus({ options,  Headertext:'My Payouts' , pillDetails:teamLeadPayoutPillStatus })
            }
            className="approvalPanel card mt-4 shadow bg-body rounded border-0"
            toggleable collapsed
        >
            {teamLeadPayoutData?.data.length > 0 ? (
                <MetricPayoutTable
                    data={teamLeadPayoutData?.data}
                    scorecardroleid={2}
                    columns={teamLeadPayoutTableColumns}
                    uniqueKey="key"
                    filterColumns={teamLeadPayoutFilterColumns}
                    currentApprovalWindow={currentApprovalWindowStatus}
                    scDisputesPill={scDisputesPill?.status}
                    approvalGrid="TeamLeadPayout"
                    scorecardVersion={scorecardVersion}
                    month={inputmonth}
                    year={inputyear}
                />
            ) : (
                <div className="card mt-3 ms-1 me-1 shadow bg-body rounded border-0">
                    <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                        <div className="row" style={{ height: '15vh' }}>
                            <div className="col-md-12" style={{ margin: 'auto', paddingTop: '10px' }}>
                                <p className="align-middle">No results found for Team Lead Payout.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Panel>
    );
};

export default TeamLeadPayout;
